import { render } from "./List.vue?vue&type=template&id=5ab433db"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_kh\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__